import request from "./request";

//受众分析
export const getAdvertiserInfo = () => request("/bi/getAdvertiserInfo", null, "POST");
export const queryAudience = (data) => request("/report/queryAudience", data, "POST");

//素材报表
export const getTag = () => request("/tag/getTag", null, "GET");
export const getDesigner = () => request("/tag/getDesigner", null, "GET");
export const materialReport = (data) => request("/report/materialReport", data, "POST_JSON");

//效果分析
export const effectAnalysis = (data) => request("/report/effectAnalysis", data, "GET");
// 广点通素材报表
export const materialReport_gdt = (data) =>
  request("/tencent/report/materialReport", data, "POST");

// 推广报表
export const getPromotionReport = (data) =>
  request("/pro/popuReport", data, "POST_JSON");
export const getPromotionOverSeaReport = (data) =>
  request("/pro/popuOverSeaReport", data, "POST_JSON");
// 查询日期配置
export const getDateConfigList = (data) => request("/dateConfig/list", data, "GET");
// 保存日期配置
export const saveDateConfig = (data) => request("/dateConfig/save", data, "POST_JSON");